// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"3f5bb364","707":"3424a9dc","729":"590247d1"}[chunkId] + ".js";
};